import styled from "styled-components";

export const StyledTextItem = styled.span`
  display: inline-block;
  padding: ${({ theme }) => theme.space.sm} 0;
  font-size: ${({ theme }) => theme.font.size.sm};
  text-decoration: inherit;
  word-break: break-word;
  hyphens: auto;

  mark {
    background: ${({ theme }) => theme.colors.yellow};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: inherit;
  }
`;
